<template>
    <div>
        <div class="calendar-container">
            <v-date-picker
                :columns="$screens({ default: 1, laptop: 2 })"
                v-model="dateVal"
                mode="range"
                locale="de"
                :max-date="new Date()"
                :popover="{ keepVisibleOnInput: true, visibility:'click'}"
                ref="datepicker"
                :disabled-dates="disabled_dates_val"
            >
                <input
                    type="text"
                    class="form-control calender-icon w-full appearance-none border rounded py-2 px-3 text-gray-700 focus:border-blue-4"
                    v-model="date_typing"
                    placeholder="TT.MM.JJJJ - TT.MM.JJJJ"
                    @input="enterDate()"
                    @blur="checkDate"
                    @keydown="emptyInputField"
                    slot-scope="{ inputProps, inputEvents, isDragging }"
                />
                <!--emptyInputField function is used to prevent the input field from user input.-->
            </v-date-picker>
            <span class="helper" @click="$refs.datepicker.$el.querySelector('input').focus()">{{placeholder_helper}}</span>
           <!-- <font-awesome-icon icon="calendar-alt" class="calendar-icon" @click.stop="openCalendar()"/>-->
        </div>
    </div>
</template>

<script>
    import EventBus from '../../EventBus';
    export default {
        data() {
            return {
                placeholder:        'TT.MM.JJJJ - TT.MM.JJJJ',
                date_typing:        this.placeholder,
                placeholder_helper: '',
                dateVal:            this.date,
                disabled_dates_val: null,
                emptyErrorMsgShown : false
            }
        },
        props: {
            id: {
                type: String,
                required: false,
                default() {
                    return 'date'
                }
            },
            date: {
                type: Object,
                required: false,
                default() {
                    return {}
                }
            },
            disabled_dates: {
                type: Object,
                required: false,
                default() {
                    return {};
                }
            },
            readonly: {
                type: Boolean,
                required: false,
                default() {
                    return false;
                }
            },
            input_name: {
                type: String,
                required: false,
                default() {
                    return '';
                }
            }
        },
        model: {
            prop: 'date',
            event: 'modified'
        },
        watch: {
            date_typing(val) {
                if(val.length == this.placeholder.length){
                    let dateArray = val.split('-');
                    if(dateArray.length < 2){
                        this.errorToast();
                    }else{
                        let start     = this.stringToDateObject(dateArray[0]);
                        let end       = this.stringToDateObject(dateArray[1]);

                        if(! isNaN(start) && ! isNaN(end)){
                            this.dateVal = {
                                start: start,
                                end:   end
                            }

                            this.placeholder_helper = '';
                        } else {
                            this.errorToast();
                        }
                    }
                }
            },
            dateVal(val) {
              if(val != null || val.start != null){
                this.date_typing = this.dateObjectToString(val.start) + " - " + this.dateObjectToString(val.end);
                this.checkDate();
                this.$emit('modified', val);
              }
            },
            date(val) {
                this.dateVal = val;
            },
            disabled_dates(val) {
                if(Object.keys(val).length > 0) {
                    this.disabled_dates_val = val;
                }else {
                    this.disabled_dates_val = null;
                }
            },
            readonly(val) {
                this.$refs['datepicker'].$el.querySelector('input').disabled = val;
                if(!val) {
                    this.openCalendar();
                }
            }
        },
        methods: {
            stringToDateObject(val) {
                let dateArray = val.split('.');
                let year = dateArray.pop();
                let month = dateArray.pop();
                let day = dateArray.pop();
                let date = new Date();

                date.setDate(day);
                date.setMonth(month - 1);
                date.setFullYear(year);

                return date;
            },
            dateObjectToString(val) {
                let day = val.getDate() + "";
                let month = (val.getMonth() + 1) + "";
                let year = val.getFullYear();

                if(day.length == 1) {
                    day = "0" + day;
                }

                if(month.length == 1) {
                    month = "0" + month;
                }

                return `${day}.${month}.${year}`;
            },
            enterDate() {
                if(this.date_typing.length != this.placeholder.length){
                    this.placeholder_helper = this.date_typing + this.placeholder.substring(this.date_typing.length);
                }
            },
            emptyInputField(e){
              e.preventDefault();
              if(!this.emptyErrorMsgShown){
                this.$bvToast.toast(this.$t('intern_meldung.date_picker_prevent_typing'), {
                  variant: 'danger',
                  title:   'Fehlermeldung'
                });
                this.emptyErrorMsgShown = true;
                setTimeout(()=>{
                  this.emptyErrorMsgShown = false;
                },6000);
              }


            },
            checkDate() {
                if(this.date_typing && this.date_typing.length > 0) {
                    if(this.date_typing.length < this.placeholder.length) {
                        let datesArray = this.date_typing.split('-');
                        if(datesArray.length < 2) {
                            this.errorToast();
                            return false;
                        } else {
                            let start = datesArray[0].split('.');
                            let end = datesArray[1].split('.');

                            if(start.length < 3 || end.length < 3) {
                                this.errorToast();
                                return false;
                            } else {
                                let regex = /^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{4}$/;
                                if(!regex.test(start) || !regex.test(end)) {
                                    this.errorToast();
                                    return false;
                                }
                            }
                        }
                    }

                    return true;
                }
            },
            errorToast() {
                this.$bvToast.toast(this.$t('intern_meldung.date_picker'), {
                    variant: 'danger',
                    title:   'Fehlermeldung'
                });
            },
            openCalendar(input = '') {
                if(this.readonly) {
                    this.$emit('date_picker', true);
                }

                if(input != '') {
                    if(this.input_name == input){
                        setTimeout(() => {
                            this.$refs['datepicker'].$el.querySelector('input').focus();
                        }, 200);
                    }
                }else{
                    this.$refs['datepicker'].$el.querySelector('input').focus();
                }
            },
            isDisabled(date) {
                let disabledDate = new Date(this.disabledDays.date);
                if(this.disabledDays.date == 0){
                    return false;
                }
                if(this.disabledDays.compare == 'ls'){
                    return date < disabledDate;
                }else {
                    return date > disabledDate;
                }
            }
        },
        created() {
            EventBus.$on('OPEN_CALENDAR', this.openCalendar);

            if(Object.keys(this.disabled_dates).length > 1){
                this.disabled_dates_val = this.disabled_dates;
            }else {
                this.disabled_dates_val = null;
            }
        },
        destroyed() {
            EventBus.$off('OPEN_CALENDAR', this.openCalendar);
        },
    }
</script>

<style scoped>
.helper {
    position: absolute;
    top: 7px;
    left: 17px;
    opacity: 0.4;
    font-size: 1rem;
}

.calender-icon{
    text-align: left;
    background-image: url(/img/admin/Calendar.svg);
    background-repeat: no-repeat;
    background-position: right;
    background-position-x: 97%;
}
</style>
